import FilterIcon from '@/assets/icons/filter-icon.svg';
import { Palette } from '@/themes/themeOverrides/Palette';

export const MuiButtonStyles = {
    styleOverrides: {
        root: {
            borderRadius: '12px',
            textTransform: 'none',
            padding: '12px 16px',
            boxShadow: 'none',
            fontSize: '14px',
            '&.white': {
                backgroundColor: Palette.white,
                boxShadow: `${Palette.boxShadow.elevation1} !important`,
                '&:hover': {
                    backgroundColor: Palette.white,
                    boxShadow: `${Palette.boxShadow.elevation2} !important`,
                },
            },
            '&.add-filter': {
                '& .MuiButton-startIcon': {
                    backgroundImage: `url("${FilterIcon}")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: 'contain',
                    width: '20px',
                    height: '20px',
                    '& svg': {
                        visibility: 'hidden',
                    },
                },
            },
            '&.MuiButton-sizeSmall': {
                lineHeight: '20px !important',
            },
            '&.MuiButton-sizeLarge': {
                lineHeight: '24px',
            },
            '&:disabled svg': {
                opacity: 0.26,
            },
            '&.button--icon-only': {
                backgroundColor: Palette.gray.gray100,
                fontSize: 0,
                minWidth: '36px',
                padding: '8px',
                '&:hover': {
                    boxShadow: `inset 0 0 0 2px ${Palette.gray.gray300}`,
                    backgroundColor: Palette.gray.gray100,
                },
                '& span.MuiButton-startIcon': {
                    margin: 0,
                },
                '&.white': {
                    backgroundColor: Palette.white,
                    padding: '12px 16px',
                    '&:hover': {
                        backgroundColor: Palette.white,
                        boxShadow: `${Palette.boxShadow.elevation2} !important`,
                    },
                    '&:focus': {
                        boxShadow: 'none',
                        outline: 'none !important',
                    },
                    '&:active': {
                        boxShadow: 'none',
                        outline: 'none !important',
                    },
                },
            },
            '&:active': {
                boxShadow: 'none',
            },
            '&.active': {
                boxShadow: `inset 0 0 0 2px ${Palette.black} !important`,
                outline: `2px solid ${Palette.yellow.yellow200}`,
            },
            '&.MuiButton-textPrimary': {
                '&:hover': {
                    boxShadow: `inset 0 0 0 2px ${Palette.gray.gray300}`,
                },
            },
            '&.MuiButton-containedSecondary': {
                backgroundColor: Palette.gray.gray150,
                letterSpacing: '-0.14px',
                '&:hover': {
                    backgroundColor: Palette.gray.gray150,
                    boxShadow: `inset 0 0 0 2px ${Palette.gray.gray300}`,
                },
                '& .MuiTouchRipple-root': {
                    display: 'none',
                },
            },
            '&.MuiButton-textSecondary': {
                backgroundColor: Palette.gray.gray150,
                '&:hover': {
                    backgroundColor: Palette.gray.gray150,
                    boxShadow: `inset 0 0 0 2px ${Palette.gray.gray300}`,
                },
            },
            '&.close-popup': {
                padding: '12px 16px',
            },
            '&.list-group': {
                padding: 0,
                textAlign: 'left',
                backgroundColor: 'transparent',
                fontWeight: '400',
                display: 'block',
                '&:hover, &:active, &:focus': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            },
            '&.end-icon': {
                '& .MuiButton-startIcon': {
                    display: 'none',
                },
                '& .MuiButton-endIcon': {
                    marginLeft: '0',
                },
            },
            '& .MuiCircularProgress-root': {
                display: 'none',
            },
        },
        contained: {
            backgroundColor: Palette.yellow.yellow400,
            color: Palette.black,
            padding: '10px 16px',
            '&:hover': {
                backgroundColor: Palette.yellow.yellow400,
                boxShadow: `inset 0 0 0 2px ${Palette.yellow.yellow600}`,
            },
        },
        outlined: {
            backgroundColor: Palette.yellow.yellow400,
            borderColor: Palette.yellow.yellow600,
            color: Palette.black,
            '&:hover': {
                borderColor: Palette.black,
            },
        },
        text: {
            color: Palette.black,
            background: Palette.white,
            '&:hover': {
                backgroundColor: 'rgba(255, 203, 0, 0.1)',
            },
            '& > svg': {
                marginRight: '8px',
            },
        },
    },
};
